<template>
  <section>
    <Feature :title="$t('QUOTATION_DATA_DETAIL')" :iconClass="'fa-check-square'">
      <FormRowTwo :fieldNameArr="[serachDetailTpye + ': ']"
        :fieldWidthArr="[412]" :fieldSpanWidthArr="[150]">
        <Input class="Input" v-model="routerValue" slot="a" disabled />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('ANNUAL_PRODUCTION_CAPACITY')+ ': ', $t('ANNUAL_OUTPUT_VALUE')+ ': ']"
        :fieldWidthArr="[412, 412]" :fieldSpanWidthArr="[150, 150]">
        <Input class="Input" v-model="annualProductionCapacity" slot="a" >
          <span slot="append">PCS</span>
        </Input>
        <Input class="Input" v-model="annualOutputValue" slot="b" >
          <span slot="append">{{ annualOutputValueCurrency }}</span>
        </Input>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('YEAR_OF_USER')+ ': ', $t('RECYCLING_YEAR')+ ': ']"
        :fieldWidthArr="[412, 412]" :fieldSpanWidthArr="[150, 150]">
        <Input class="Input" v-model="yearOfUse" slot="a">
        <span slot="append">{{ $t('YEARS') }}</span>
          </Input>
        <Input class="Input" v-model="recyclingYear" slot="b">
          <span slot="append">{{ $t('YEARS') }}</span>
        </Input>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('BENEFIT_ANALYSIS') + ': ']"
        :fieldWidthArr="[1000]" :fieldSpanWidthArr="[150]">
        <Input class="Input" v-model="benefitAnalysis" style="width: 800px" slot="a" type="textarea" :maxlength="500" />
      </FormRowTwo>
      <FormRowTwo v-if="!isGroupType && selectAllAble" :fieldNameArr="[$t('SELECT_ALL')+ ': ', '']"
        :fieldWidthArr="[412]" :fieldSpanWidthArr="[150]">
        <RadioGroup class="Input" v-model="selectAllType" @on-change="changeSelectAll" slot="a">
          <Radio label="Delete"></Radio>
          <Radio label="Approve"></Radio>
          <Radio label="Rejected"></Radio>
        </RadioGroup>
        <Button type="primary" @click="cleanSelect" slot="b">{{ $t('CLEAR_SELECT') }}</Button>
      </FormRowTwo>
      <FormRowTwo v-if="isGroupType && selectAllAble" :fieldNameArr="[$t('SELECT_ALL')+ ': ', '']"
        :fieldWidthArr="[412]" :fieldSpanWidthArr="[150]">
        <RadioGroup class="Input" v-model="selectAllType" @on-change="changeSelectAll" slot="a">
          <Radio label="Un-Group"></Radio>
          <Radio label="Approve"></Radio>
        </RadioGroup>
        <Button type="primary" @click="cleanSelect" slot="b">{{ $t('CLEAR_SELECT') }}</Button>
      </FormRowTwo>
      <TablePage :tableWidth="windowWidth" :columnsList="quotationColumnList" :resultList="quotationList"
        :tableMaxHeight="500"></TablePage>
    </Feature>
    <ButtonRow v-if="!isGroupType">
      <Button type="primary" @click="Submit" slot="1">{{ $t('SUBMIT') }}</Button>
      <Button type="primary" @click="Back" slot="2">{{ $t('BACK') }}</Button>
    </ButtonRow>
    <ButtonRow v-if="isGroupType">
      <Button type="primary" @click="UnGroup" slot="1">{{ $t('UNGROUP') }}</Button>
      <Button type="primary" @click="GroupApprove" slot="2">{{ $t('APPROVE') }}</Button>
      <Button type="primary" @click="Back" slot="3">{{ $t('BACK') }}</Button>
    </ButtonRow>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="logModel"
      :title="$t('PROCESS_LOG')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <TablePage :columnsList="quotationLogColumnList" :resultList="quotationLogList" :tableMaxHeight="800"></TablePage>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="supplierQuotationFilesModel" :title="$t('QUOTATION_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="supplierQuotationFiles"></FileDocument>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="toolingAttachmentsModel" :title="$t('SPEC_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table width="600" border :columns="fileSchemaList" :data="toolingAttachments">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadToolingAttachment(row)"></Button>
          </template>
        </Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="abnormalsModel"
      :title="$t('ABNORMAL')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="abnormalColumnList" :data="abnormals" max-height="800"></Table>
      </div>
    </Modal>
    <Modal
      v-model="commentsModal"
      :title="$t('COMMENTS')"
      :draggable="true"
      :sticky="true"
      :reset-drag-position="true"
      :ok-text="$t('SAVE')"
      :width="900"
      :z-index="modalSize"
      @on-ok="confirmComments"
    >
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="remarkModel"
      :title="$t('REMARK')" @on-ok="confirmRemark">
      <froala :config="FloraEditorConfig" v-model="remark"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="referencePriceModel" :title="$t('REFERENCE_PRICE_DATA')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="referencePriceColumnList" :data="referencePrices" max-height="800"></Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300" v-model="toolingModel"
      :title="$t('TOOLING_ATTRIBUTES')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <ToolingAttributes :toolingQuotationType="toolingQuotationType" :tooling="tooling"></ToolingAttributes>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="cpcToSupervisorAttachmentsModel" :title="$t('APPROVE') + ' ' + $t('REFERENCE_FILE')">
      <FormRow
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadCpcToSupervisorAttachments">{{
          $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
      <FormRow v-if="cpcToSupervisorAttachmentsExited" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToSupervisorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download"
              @click="downloadCpcToSupervisorAttachment(row)"></Button>
            <Button type="error" shape="circle" icon="md-close-circle"
              @click="deleteCpcToSupervisorDocument(row)"></Button>
          </template>
        </Table>
      </FormRow>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="cpcToVendorAttachmentsModel" :title="$t('REJECT') + ' ' + $t('REFERENCE_FILE')">
      <FormRow
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadCpcToVendorAttachments">{{ $t('CLICK_UPLOAD')
        }}</Button>
      </FormRow>
      <FormRow v-if="cpcToVendorAttachmentsExited" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToVendorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadCpcToVendorAttachment(row)"></Button>
            <Button type="error" shape="circle" icon="md-close-circle" @click="deleteCpcToVendorAttachment(row)"></Button>
          </template>
        </Table>
      </FormRow>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="flowCommentModel" :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="flowComment"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="logCommentModel"
      :title="$t('HISTORY') + ' ' + $t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="logComment"></froala>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertSuccess, AlertError } from "@/util/alert"
import FileDocument from '../../components/FileDocument.vue'
import { Translate, FloraEditorConfig } from "@/util/common"
import { FileSchemaList, ToolingMaterial } from "@/util/tableTitle"
import moment from "moment"
import FormRowTwo from '@/components/FormRowTwo'
import ToolingAttributes from "@/views/quotation/ToolingAttributes"

export default {
  name: "CpcToolingDetailMaintain",
  components: {
    FileDocument,
    FormRowTwo,
    ToolingAttributes
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      actionType: '',
      selectAllType: '',
      serachDetailTpye: '',
      routerValue: '',
      statusList: '',
      tooling: {},
      isFormNoType: false,
      isPartNoType: false,
      isVendorNameType: false,
      isGroupType: false,
      logModel: false,
      supplierQuotationFilesModel: false,
      abnormalsModel: false,
      commentsModal: false,
      remarkModel: false,
      referencePriceModel: false,
      toolingModel: false,
      toolingAttachmentsModel: false,
      cpcToSupervisorAttachmentsModel: false,
      cpcToVendorAttachmentsModel: false,
      flowCommentModel: false,
      logComment: '',
      logCommentModel: false,
      quotationDocuments: [],
      quotationUuid: '',
      quotationLogList: [],
      supplierQuotationFiles: [],
      cpcToSupervisorAttachments: [],
      cpcToVendorAttachments: [],
      toolingAttachments: [],
      abnormals: [],
      comments: '',
      remark: '',
      defaultValidTo: '',
      toolingQuotationType: '',
      flowComment: '',
      file: null,
      fileSchemaList: FileSchemaList(this),
      materialColumn: ToolingMaterial(this),
      annualProductionCapacity: '',
      annualOutputValue: '',
      yearOfUse: '',
      recyclingYear: '',
      benefitAnalysis: '',
      isBenefitAnalysisValid: false,
      moldColumn: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_MATERIAL');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'material'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_RAW_MATERIAL_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'rawMaterialPrice'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_PROCESSING_FEE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'processingFee'
        }
      ],
      engineeringColumn: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENGINEERING_TL_QUANTITY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'quantity'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENGINEERING_WEIGHT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'weight'
        }
      ],
      referencePriceColumnList: [],
      newReferencePriceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 200,
          key: "createDate",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TOOLING_ID');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 300,
          key: "toolingId",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 250,
          key: "unitPrice",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "currency",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 200,
          key: "vendor",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('OA_VENDOR_NAME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 300,
          align: "center",
          key: "vendorName",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CAVITY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "cavity",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "validationDate",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('LIFETIME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "lifeTime",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('USED_LIFETIME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "usedLifeTime",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMPARE_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "comparePrice",
        },
      ],
      otherReferencePriceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('APPLICATION_TYPE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 130,
          key: "toolingQuotationType",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 200,
          key: "createDate",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "validationDate",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 200,
          key: "vendor",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('OA_VENDOR_NAME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 300,
          align: "center",
          key: "vendorName",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 250,
          key: "unitPrice",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "currency",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('LIFETIME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "lifeTime",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('USED_LIFETIME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "usedLifeTime",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PROPORTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "proportion",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMMENTS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 150,
          key: "comments",
        }
      ],
      referencePrices: [],
      scalePriceColumnList: [
        {
          title: 'Item',
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scaleQuantity',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scalePrice'
        }
      ],
      abnormalColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'item',
          width: 100,
          align: "center",
          render: (h, params) => {
            let status = "";
            if (params.row["status"].statusViewEnum == "CANCEL") {
              status = "Cancel"
            } else if (params.row["status"].statusViewEnum == "WAITING_SUPPLIER" || params.row["status"].statusViewEnum == "SUPPLIER") {
              status = "Reject"
            }
            return h("span", {}, status)
          }
        },
        {
          title: "Form NO.",
          align: 'center',
          width: 140,
          key: "formNo"
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 130,
          render: (h, params) => {
            return h("span", {}, params.row["rfqType"].description + " (" + params.row.toolingQuotationType + ")")
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('DELTA_PN') + '<br>' + this.$t('PN_DESCRIPTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          render: (h, params) => {
            let deltaPart = params.row.deltaPart != undefined ? params.row.deltaPart : ""
            let deltaPartDesc = params.row.deltaPartDesc != undefined ? params.row.deltaPartDesc : ""
            let text = deltaPart + "<br>" + deltaPartDesc
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 140,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "currency",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "price",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REFERENCE_PRICE_DATA')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 65,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: params.row.tooling && params.row.tooling.references ? (params.row.tooling.references.length > 0 ? "ios-paper" : "") : "",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.referencePrices = params.row.tooling.references
                  this.referencePriceModel = true
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTATION') + '<br>' + this.$t('FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: params.row["supplierQuotationFiles"] && params.row["supplierQuotationFiles"].filter(attachment => !attachment.deleted).length > 0 ? "ios-cloud-download" : "",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.supplierQuotationFiles = []
                  this.supplierQuotationFiles = params.row.supplierQuotationFiles.filter(attachment => !attachment.deleted)
                  this.supplierQuotationFilesModel = true
                },
              },
            })
          }
        },
        // {
        //   title: this.$t('LOG'),
        //   width: 120,
        //   align: 'center',
        //   render: (h, params) => {
        //     if (params.row.resourceType == "SupervisorQuotationDetailDto" && params.row.quotationLogList === undefined) {
        //       this.$set(this.quotationList[params.index], 'quotationLogList', []);
        //       this.$queryQuotationLog(this, params.row.uuid).then(data => {
        //         this.$set(this.quotationList[params.index], 'quotationLogList', data);
        //       }).catch((error) => {
        //         AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
        //         })
        //       })
        //     }
        //     return h("Icon", {
        //       props: {
        //         type: params.row.quotationLogList ? (params.row.quotationLogList.length > 0 ? "ios-paper" : "ios-loading") : "",
        //         size: 28,
        //       },
        //       class: "text-delta-blue",
        //       on: {
        //         click: () => {
        //           if (params.row.quotationLogList && params.row.quotationLogList.length > 0) {
        //             this.quotationUuid = params.row.uuid
        //             this.quotationLogList = params.row.quotationLogList
        //             this.logModel = true
        //           }
        //         },
        //       },
        //     })
        //   }
        // },
        {
          renderHeader: (h, params) => {
            var text = this.$t('LOG')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$queryQuotationLog(this, params.row.uuid).then(data => {
                    this.toggleLoading(false)
                    this.quotationUuid = params.row.uuid
                    this.quotationLogList = data
                    this.logModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
      ],
      quotationLogColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ROLE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "quotationRole",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "flowStatus",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "groupAccount",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("span", {}, params.row["groupAccount"].companyName)
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "flowAction",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMMENTS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render: (h, params) => {
            if (params.row.flowComment) {
              return h("Icon", {
                props: {
                  type: "ios-paper",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.flowComment = params.row.flowComment
                    this.flowCommentModel = true
                  },
                },
              })
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "created",
          width: 180,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PERSON_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "personEmail",
          width: 200,
          align: "center",
        },
      ],
      quotationList: [],
      quotationColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          render: (h, params) => {
            let result = []
            if (this.$route.name == "CPC_MAINTAIN_DETAIL_TOOLING_GROUP_ID") {
              if (params.row.status.statusViewEnum == "WAITING_BUYER") {
                result = [
                  h("Radio", {
                    style: {
                      display: "inline-block",
                      "font-size": "14px"
                    },
                    props: {
                      label: "Un-Group",
                    }
                  }),
                  h("Radio", {
                    style: {
                      display: "inline-block",
                      "font-size": "14px"
                    },
                    props: {
                      label: "Approve",
                    }
                  })
                ]
              }
            } else if (params.row.status.statusViewEnum == "WAITING_BUYER") {
              result = [
                h("Radio", {
                  style: {
                    display: "inline-block",
                    "font-size": "14px"
                  },
                  props: {
                    label: "Delete",
                  }
                }),
                h("Radio", {
                  style: {
                    display: "inline-block",
                    "font-size": "14px"
                  },
                  props: {
                    label: "Approve",
                  }
                }),
                h("Radio", {
                  style: {
                    display: "inline-block",
                    "font-size": "14px"
                  },
                  props: {
                    label: "Rejected",
                  }
                })
              ]
            } else if (params.row.status.statusViewEnum == "WAITING_SUPPLIER") {
              result = [
                h("Radio", {
                  style: {
                    display: "inline-block",
                    "font-size": "14px"
                  },
                  props: {
                    label: "Delete",
                  }
                })
              ]
            }
            return h("RadioGroup",
              {
                props: {
                  value: this.quotationList[params.index].action
                },
                on: {
                  "on-change": (val) => {
                    this.$set(this.quotationList[params.index], 'action', val);
                  }
                }
              },
              result
            );
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMMENTS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 90,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-create",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.comments = this.quotationList[params.index].comments ? this.quotationList[params.index].comments : ""
                  this.actionType = this.quotationList[params.index].action ? this.quotationList[params.index].action : ""
                  this.quotationUuid = params.row.id
                  this.commentsModal = true
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('HISTORY') + '<br>' + this.$t('COMMENTS')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$queryQuotationLog(this, params.row.uuid).then(data => {
                    this.toggleLoading(false)
                    this.logComment = ""
                    this.quotationUuid = params.row.uuid
                    data.forEach(log => {
                      if (log.quotationRole) {
                        this.logComment = this.logComment + this.$t('ROLE') + ': ' + log.quotationRole + ', '
                      }
                      if (log.quotationRole) {
                        this.logComment = this.logComment + this.$t('STATUS') + ': ' + log.flowStatus + ', '
                      }
                      if (log.groupAccount) {
                        this.logComment = this.logComment + this.$t('GROUP_ACCOUNT') + ': ' + log.groupAccount.code + '/' + log.groupAccount.companyName + ', '
                      }
                      if (log.created) {
                        this.logComment = this.logComment + this.$t('CREATE_DATE') + ': ' + log.created + ': <br>'
                      }
                      if (log.flowComment) {
                        this.logComment = this.logComment + log.flowComment
                      }
                      this.logComment = this.logComment + '<hr style="border:1px dashed #000; height:1px">'
                    })
                    this.logCommentModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 85,
          align: "center",
          render: (h, params) => {
            return h("span", {}, params.row["rfqType"].description + " (" + params.row.toolingQuotationType + ")")
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ABNORMAL');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            if (params.row.abnormals === undefined) {
              this.$set(this.quotationList[params.index], 'abnormals', []);
              this.$queryAbnormals(this, params.row.uuid).then(data => {
                this.$set(this.quotationList[params.index], 'abnormals', data);
              }).catch((error) => {
                AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                })
              })
            }
            return h("Icon", {
              props: {
                type: params.row.abnormals ? (params.row.abnormals.length > 0 ? "ios-warning" : "ios-loading") : "",
                size: 28,
              },
              class: "text-delta-red",
              on: {
                click: () => {
                  if (params.row.abnormals && params.row.abnormals.length > 0) {
                    this.quotationUuid = params.row.uuid
                    this.abnormals = params.row.abnormals
                    this.abnormalsModel = true
                  }
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TOOLING_ID');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: "center",
          key: "toolingId",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 90,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('TARGET') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          render: (h, params) => {
            if (params.row.status.statusViewEnum == "WAITING_BUYER") {
              return h("Input", {
                props: {
                },
                style: {
                  textAlign: "center"
                },
                props: {
                  type: 'text',
                  value: params.row.targetPrice
                },
                on: {
                  'on-change': (event) => {
                    this.quotationList[params.index].targetPrice = event.target.value
                  }
                }
              })
            } else {
              return h("span", {}, params.row.targetPrice)
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE') + "<br>" + this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 90,
          render: (h, params) => {
            if (params.row.abnormals && params.row.abnormals.quoteRedAlert || params.row.quoteRedAlert) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'error',
                    shape: "circle",
                    size: 'small'
                  },
                  style: { width: '80%' },
                }, params.row.price),
                h("span", {}, '/' + params.row.currency)
              ]);
            } else {
              let price = params.row.price != undefined ? params.row.price : ""
              let currency = params.row.currency != undefined ? params.row.currency : ""
              let text = price + '/' + currency
              return h('div', {
                domProps: {
                  innerHTML: text
                }
              })
            }
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('BASIC') + '<br>' + this.$t('UNIT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          key: "unit",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT_CODE_TITLE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 50,
          key: "plant",
        },
        // {
        //   title: this.$t('SPEC_FILE'),
        //   align: 'center',
        //   width: 150,
        //   align: 'center',
        //   render: (h, params) => {
        //     return h("Icon", {
        //       props: {
        //         type: params.row.tooling && params.row.tooling.attachments ? (params.row.tooling.attachments.length > 0 ? "ios-paper" : "") : "",
        //         size: 28,
        //       },
        //       class: "text-delta-blue",
        //       on: {
        //         click: () => {
        //           this.quotationUuid = params.row.uuid
        //           this.toolingAttachments = params.row.tooling.attachments
        //           this.toolingAttachmentsModel = true
        //         },
        //       },
        //     })
        //   }
        // },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SPEC') + '<br>' + this.$t('FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$readTooling(this, params.row.formNo, false).then(data => {
                    this.toggleLoading(false)
                    this.quotationUuid = params.row.uuid
                    this.toolingAttachments = data.attachments
                    this.toolingAttachmentsModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTATION') + '<br>' + this.$t('FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 60,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: params.row["supplierQuotationFiles"] && params.row["supplierQuotationFiles"].filter(attachment => !attachment.deleted).length > 0 ? "ios-cloud-download" : "",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.supplierQuotationFiles = []
                  this.supplierQuotationFiles = params.row.supplierQuotationFiles.filter(attachment => !attachment.deleted)
                  this.supplierQuotationFilesModel = true
                },
              },
            })
          }
        },
        // {
        //   title: this.$t('TOOLING_ATTRIBUTES'),
        //   align: 'center',
        //   width: 180,
        //   align: 'center',
        //   render: (h, params) => {
        //     if (params.row.tooling === undefined) {
        //       this.$set(this.quotationList[params.index], 'tooling', []);
        //       this.$readTooling(this, params.row.formNo, false).then(data =>{
        //         this.$set(this.quotationList[params.index], 'tooling', data);
        //       }).catch((error) => {
        //         AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
        //         })
        //       })
        //     }
        //     return h("Icon", {
        //       props: {
        //         type: params.row.tooling ? (JSON.stringify(params.row.tooling) != '{}' ? "ios-paper" : "ios-loading") : "",
        //         size: 28,
        //       },
        //       class: "text-delta-blue",
        //       on: {
        //         click: () => {
        //           if (params.row.tooling) {
        //             this.toolingQuotationType = params.row.toolingQuotationType
        //             this.quotationUuid = params.row.uuid
        //             this.tooling = params.row.tooling
        //             this.toolingModel = true
        //           }
        //         },
        //       },
        //     })
        //   }
        // },
        {
          renderHeader: (h, params) => {
            var text = this.$t('TOOLING') + '<br>' + this.$t('ATTRIBUTES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$readTooling(this, params.row.formNo, false).then(data => {
                    this.toggleLoading(false)
                    this.toolingQuotationType = params.row.toolingQuotationType
                    this.quotationUuid = params.row.uuid
                    this.tooling = data
                    this.toolingModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        // {
        //   title: this.$t('REFERENCE_PRICE_DATA'),
        //   align: 'center',
        //   width: 180,
        //   align: 'center',
        //   render: (h, params) => {
        //     return h("Icon", {
        //       props: {
        //         type: params.row.tooling && params.row.tooling.references ? (params.row.tooling.references.length > 0 ? "ios-paper" : "") : "",
        //         size: 28,
        //       },
        //       class: "text-delta-blue",
        //       on: {
        //         click: () => {
        //           this.referencePrices = params.row.tooling.references
        //           this.referencePriceModel = true
        //         },
        //       },
        //     })
        //   }
        // },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REFERENCE_PRICE_DATA')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 65,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$readTooling(this, params.row.formNo, false).then(data => {
                    this.toggleLoading(false)
                    this.referencePrices = data.references
                    this.referencePriceColumnList = this.newReferencePriceColumnList
                    this.referencePriceModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REMARK')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 50,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-create",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.remark = this.quotationList[params.index].remark
                  this.quotationUuid = params.row.id
                  this.remarkModel = true
                },
              },
            })
          }
        },
        // {
        //   title: this.$t('LOG'),
        //   width: 120,
        //   align: 'center',
        //   render: (h, params) => {
        //     if (params.row.resourceType == "SupervisorQuotationDetailDto" && params.row.quotationLogList === undefined) {
        //       this.$set(this.quotationList[params.index], 'quotationLogList', []);
        //       this.$queryQuotationLog(this, params.row.uuid).then(data => {
        //         this.$set(this.quotationList[params.index], 'quotationLogList', data);
        //       }).catch((error) => {
        //         AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
        //         })
        //       })
        //     }
        //     return h("Icon", {
        //       props: {
        //         type: params.row.quotationLogList ? (params.row.quotationLogList.length > 0 ? "ios-paper" : "ios-loading") : "",
        //         size: 28,
        //       },
        //       class: "text-delta-blue",
        //       on: {
        //         click: () => {
        //           if (params.row.quotationLogList && params.row.quotationLogList.length > 0) {
        //             this.quotationUuid = params.row.uuid
        //             this.quotationLogList = params.row.quotationLogList
        //             this.logModel = true
        //           }
        //         },
        //       },
        //     })
        //   }
        // },
        {
          renderHeader: (h, params) => {
            var text = this.$t('LOG')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 50,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$queryQuotationLog(this, params.row.uuid).then(data => {
                    this.toggleLoading(false)
                    this.quotationUuid = params.row.uuid
                    this.quotationLogList = data
                    this.logModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('APPROVE') + "<br>" + this.$t('REFERENCE_FILE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-cloud-upload",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.quotationUuid = params.row.uuid
                  this.cpcToSupervisorAttachments = this.quotationList[params.index].cpcToSupervisorAttachments ? this.quotationList[params.index].cpcToSupervisorAttachments.filter(attachment => !attachment.deleted) : []
                  this.cpcToSupervisorAttachmentsModel = true
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REJECT') + "<br>" + this.$t('REFERENCE_FILE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 70,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-cloud-upload",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.quotationUuid = params.row.uuid
                  this.cpcToVendorAttachments = this.quotationList[params.index].cpcToVendorAttachments ? this.quotationList[params.index].cpcToVendorAttachments.filter(attachment => !attachment.deleted) : []
                  this.cpcToVendorAttachmentsModel = true
                },
              },
            })
          }
        },
      ]
    }
  },
  created() {
    this.defaultValidTo = getDefaultValidTo();
    search(this)
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getCpcQuotationId", "getCpcDeltaPnSingle", "getCpcOaCode", "getCpcGroupId", "getCpcFormNo"
      , "getCpcRfqType", "getCpcDeltaPn", "getCpcVendorPn", "getCpcVendorCode", "getCpcFromRfqDate", "getCpcToRfqDate", "getCpcStatusEnum", "getCpcGroupUuid"
      , "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    changeSelectAll() {
      this.quotationList.forEach(quotation => {
        let index = this.quotationList.findIndex(temp => temp.uuid == quotation.uuid)
        this.$set(this.quotationList[index], 'action', this.selectAllType);
      })
    },
    cleanSelect() {
      this.selectAllType = ""
      this.quotationList.forEach(quotation => {
        let index = this.quotationList.findIndex(temp => temp.uuid == quotation.uuid)
        this.$set(this.quotationList[index], 'action', undefined);
      })
    },
    UnGroup() {
      let vueInstance = this
      let promiseList = []
      vueInstance.toggleLoading(true)
      vueInstance.quotationList.forEach(quotation => {
        if (quotation.action && quotation.action == "Un-Group") {
          promiseList.push(unGroup(quotation, vueInstance))
        }
      })
      if (promiseList.length > 0) {
        Promise.all(promiseList).then(responseList => {
          vueInstance.toggleLoading(false)
          let msg = ""
          responseList.forEach(response => {
            if (response.content[0].status.includes("Un-Group")) {
              vueInstance.quotationList.splice(vueInstance.quotationList.findIndex(quotation => quotation.formNo == response.content[0].id), 1)
              msg = msg.concat("From No: ", response.content[0].id, ", ", response.content[0].status, "<br>")
            }
          })
          vueInstance.$Swal.fire({
            icon: "info",
            title: vueInstance.$t("COMMON_MESSAGE_INFO"),
            html: msg,
          })
          if (vueInstance.quotationList.length == 0) {
            vueInstance.$router.push({ name: 'CPC_MAINTAIN' })
          } else if (vueInstance.quotationList.length == 1) {
            unGroup(vueInstance.quotationList[0], vueInstance)
            vueInstance.$router.push({ name: 'CPC_MAINTAIN' })
          }
        })
      } else {
        vueInstance.toggleLoading(false)
        vueInstance.$Swal.fire({
          icon: "info",
          title: vueInstance.$t("COMMON_MESSAGE_INFO"),
          html: "No Select Un-Group Data",
        })
      }
    },
    GroupApprove() {
      let vueInstance = this
      let isGroupApprove = true
      vueInstance.quotationList.forEach(quotation => {
        if (!quotation.action || quotation.action != "Approve") {
          isGroupApprove = false
        }
      })

      if (isGroupApprove) {
        if (validation(vueInstance.quotationList, vueInstance)) {
          let cpcRequestDataList = []
          vueInstance.quotationList.forEach(quotation => {
            cpcRequestDataList.push(buildCpcRequestData(vueInstance, quotation))
          })
          let inputData = {
            'groupUuid': vueInstance.routerValue,
            "annualProductionCapacity": vueInstance.annualProductionCapacity,
            "annualOutputValue": vueInstance.annualOutputValue,
            "yearOfUse": vueInstance.yearOfUse,
            "recyclingYear": vueInstance.recyclingYear,
            "benefitAnalysis": vueInstance.benefitAnalysis,
            'cpcApproveqQuotationRequestDtoList': cpcRequestDataList
          }

          vueInstance.toggleLoading(true)
          approveGroup(inputData, vueInstance).then(response => {
            vueInstance.toggleLoading(false)
            vueInstance.$Swal.fire({
              icon: "info",
              title: vueInstance.$t("COMMON_MESSAGE_INFO"),
              html: "Group: " + response.content[0].id + ", " + response.content[0].status,
            })
            vueInstance.$router.push({ name: 'CPC_MAINTAIN' })
          });
        }
      } else {
        AlertInfo(vueInstance, vueInstance.$t('MUST_APPROVE_ALL')).then(() => {
        })
      }
    },
    Submit() {
      const vueInstance = this;
      let quotationListForSubmit = vueInstance.quotationList
        .filter(quotation => quotation.action === "Approve" || quotation.action === "Rejected" || quotation.action === "Delete");
      if (quotationListForSubmit.length === 0) {
        AlertInfo(vueInstance, "No Select Submit Data")
          .then(() => {});
        return;
      }
      let errorMessageArray = quotationListForSubmit
        .filter(quotation => !quotation.comments)
        .map(quotation => quotation.formNo + ": " + vueInstance.$t("PLEASE_KEY_IN") + vueInstance.$t("COMMENTS"));
      if (errorMessageArray.length > 0) {
        AlertInfo(vueInstance, errorMessageArray.join("<br/>"))
          .then(() => {});
        return;
      }
      let approveList = [];
      let rejectList = [];
      let deleteList = [];
      quotationListForSubmit.forEach(quotation => {
        let action = quotation.action;
        switch (action) {
          case "Approve":
            approveList.push(quotation);
            break;
          case "Rejected":
            rejectList.push(quotation);
            break;
          case "Delete":
            deleteList.push(quotation);
            break;
        }
      })
      let promiseList = [];
      if (approveList.length > 0) {
        promiseList.push(vueInstance.$quotationHttp
          .post("/cpc/tooling/approve", {
            annualProductionCapacity: vueInstance.annualProductionCapacity,
            annualOutputValue: vueInstance.annualOutputValue,
            yearOfUse: vueInstance.yearOfUse,
            recyclingYear: vueInstance.recyclingYear,
            benefitAnalysis: vueInstance.benefitAnalysis,
            quotationRequestList: approveList.map(quotation => {
              return {
                uuid: quotation.uuid,
                comments: quotation.comments,
                targetPrice: quotation.targetPrice,
                cpcToSupervisorFileVaultList: quotation.cpcToSupervisorAttachments,
                remark: quotation.remark
              };
            })
          }));
      }
      if (rejectList.length > 0) {
        promiseList.push(vueInstance.$quotationHttp
          .post("/cpc/reject", {
            quotationRequestList: rejectList.map(quotation => {
              return {
                formNo: quotation.formNo, 
                comments: quotation.comments, 
                cpcToVendorFileVaultList: quotation.cpcToVendorAttachments
              };
            })
          }));
      }
      if (deleteList.length > 0) {
        promiseList.push(vueInstance.$quotationHttp
          .post("/cpc/tooling/delete", {
            quotationRequestList: deleteList.map(quotation => {
              return {
                formNo: quotation.formNo, 
                comments: quotation.comments
              };
            })
          }));
      }
      if (promiseList.length === 0) {
        return;
      }
      vueInstance.toggleLoading(true);
      Promise.all(promiseList)
        .then(responseList => {
          let response1 = responseList[0];
          if (response1 === undefined) {
            return true;
          }
          if (response1.status === 200) {
            if (approveList.length === 0) {
              if (rejectList.length === 0) {
                deleteList.forEach(deleteQuotation => {
                  vueInstance.quotationList.splice(vueInstance.quotationList.findIndex(quotation => quotation.formNo === deleteQuotation.formNo), 1);
                });
              } else {
                rejectList.forEach(rejectQuotation => {
                  vueInstance.quotationList.splice(vueInstance.quotationList.findIndex(quotation => quotation.formNo === rejectQuotation.formNo), 1);
                });
              }
            } else {
              approveList.forEach(approveQuotation => {
                vueInstance.quotationList.splice(vueInstance.quotationList.findIndex(quotation => quotation.uuid === approveQuotation.uuid), 1);
              });
            }
          }
          let response2 = responseList[0];
          if (response2 === undefined) {
            return true;
          }
          if (response2.status === 200) {
            if (rejectList.length === 0) {
              deleteList.forEach(deleteQuotation => {
                vueInstance.quotationList.splice(vueInstance.quotationList.findIndex(quotation => quotation.formNo === deleteQuotation.formNo), 1);
              });
            } else {
              rejectList.forEach(rejectQuotation => {
                vueInstance.quotationList.splice(vueInstance.quotationList.findIndex(quotation => quotation.formNo === rejectQuotation.formNo), 1);
              });
            }
          }
          let response3 = responseList[0];
          if (response3 === undefined) {
            return true;
          }
          if (response3.status === 200) {
            deleteList.forEach(deleteQuotation => {
              vueInstance.quotationList.splice(vueInstance.quotationList.findIndex(quotation => quotation.formNo === deleteQuotation.formNo), 1);
            });
          }
          return true;
        })
        .then(result => {
          if (result === true) {
            AlertSuccess(vueInstance, vueInstance.$t("COMMON_MESSAGE_SUCCESSFULLY"))
              .then(() => {
                if (vueInstance.quotationList.length == 0) {
                  vueInstance.$router.push({
                    name: "CPC_MAINTAIN"
                  });
                }
              });
          }
        })
        .catch(error => {
          console.error(error);
          AlertError(vueInstance, error)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    Back() {
      this.$router.push({ name: 'CPC_MAINTAIN' })
    },
    confirmComments() {
      const vueInstance = this;
      const formNoList = [];
      const comments = vueInstance.comments;
      vueInstance.quotationList.forEach(temp => {
        if (temp.uuid === vueInstance.quotationUuid || (vueInstance.actionType && vueInstance.actionType === temp.action)) {
          temp.comments = vueInstance.comments;
          formNoList.push(temp.formNo);
        }
      });
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .patch("/cpc/batchUpdateComments", { formNoList, comments })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    confirmRemark() {
      this.quotationList.forEach(temp => {
        if (temp.uuid == this.quotationUuid) {
          temp.remark = this.remark
        }
      })
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadCpcToSupervisorAttachments() {
      let fd = new FormData()
      fd.append('file', this.file)
      fd.append('description', "quotaion attachement")
      this.toggleLoading(true)
      this.$fileHttp
        .post("/attachment/upload-single?description=quotation" + this.quotationUuid, fd)
        .then((response) => {
          this.toggleLoading(false)
          this.cpcToSupervisorAttachments.push(response.data)
          this.quotationList.forEach(quotation => {
            if (quotation.uuid == this.quotationUuid) {
              if (!quotation.cpcToSupervisorAttachments) {
                quotation.cpcToSupervisorAttachments = []
              }
              quotation.cpcToSupervisorAttachments.push(response.data)
            }
          })
          this.file = null
          this.toggleLoading(false)
        })
        .catch(() => { })
    },
    downloadCpcToSupervisorAttachment(row) {
      this.$downloadAttachment(this, row.id)
    },
    deleteCpcToSupervisorDocument(row) {
      let temp
      this.quotationList.forEach(quotation => {
        if (quotation.uuid == this.quotationUuid) {
          temp = quotation
          quotation.cpcToSupervisorAttachments.forEach(attachment => {
            if (attachment.id == row.id) {
              attachment.deleted = true
            }
          })
        }
      })
      this.cpcToSupervisorAttachments = temp.cpcToSupervisorAttachments.filter(attachment => !attachment.deleted)
    },
    uploadCpcToVendorAttachments() {
      let fd = new FormData()
      fd.append('file', this.file)
      fd.append('description', "quotaion attachement")
      this.toggleLoading(true)
      this.$fileHttp
        .post("/attachment/upload-single?description=quotation" + this.quotationUuid, fd)
        .then((response) => {
          this.toggleLoading(false)
          this.cpcToVendorAttachments.push(response.data)
          this.quotationList.forEach(quotation => {
            if (quotation.uuid == this.quotationUuid) {
              if (!quotation.cpcToVendorAttachments) {
                quotation.cpcToVendorAttachments = []
              }
              quotation.cpcToVendorAttachments.push(response.data)
            }
          })
          this.file = null
          this.toggleLoading(false)
        })
        .catch(() => { })
    },
    downloadCpcToVendorAttachment(row) {
      this.$downloadAttachment(this, row.id)
    },
    deleteCpcToVendorAttachment(row) {
      let temp
      this.quotationList.forEach(quotation => {
        if (quotation.uuid == this.quotationUuid) {
          temp = quotation
          quotation.cpcToVendorAttachments.forEach(attachment => {
            if (attachment.id == row.id) {
              attachment.deleted = true
            }
          })
        }
      })
      this.cpcToVendorAttachments = temp.cpcToVendorAttachments.filter(attachment => !attachment.deleted)
    },
    downloadToolingAttachment(row) {
      this.$downloadToolingAttachment(this, this.quotationUuid, row.uuid)
    },
  },
  computed: {
    cpcToSupervisorAttachmentsExited() {
      return this.cpcToSupervisorAttachments.length > 0
    },
    cpcToVendorAttachmentsExited() {
      return this.cpcToVendorAttachments.length > 0
    },
    selectAllAble() {
      return this.getCpcStatusEnum()['statusViewEnum'] == "WAITING_BUYER" || this.getCpcStatusEnum()['statusViewEnum'] == "WAITING_SUPPLIER"
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    },
    annualOutputValueCurrency() {
      return this.quotationList[0]?.currency
    }
  }
}

function getDefaultValidTo() {
  let today = new Date();
  if ((today.getMonth() + 1) > 9) {
    return moment([today.getFullYear() + 1, 11, 31]).format("YYYY-MM-DD")
  } else {
    return moment([today.getFullYear(), 11, 31]).format("YYYY-MM-DD")
  }
}

function search(vueInstance) {
  vueInstance.selectAllType = ""
  let url = ""
  if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_TOOLING_FORM_NO") {
    vueInstance.serachDetailTpye = "Form. No"
    vueInstance.routerValue = vueInstance.getCpcFormNo()
    url = "/cpc/detail/" + vueInstance.getCpcQuotationId()
    getSearch(vueInstance, url)
  } else if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_TOOLING_GROUP_ID") {
    vueInstance.isGroupType = true
    vueInstance.serachDetailTpye = vueInstance.$t('GROUP_KEY')
    vueInstance.routerValue = vueInstance.getCpcGroupId()
    url = "/cpc/details/group/" + vueInstance.getCpcGroupUuid()
    getSearch(vueInstance, url)
  } else if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_TOOLING_ID") {
    vueInstance.serachDetailTpye = vueInstance.$t("TOOLING_ID")
    vueInstance.routerValue = vueInstance.getCpcDeltaPnSingle()
    url = "/cpc/details/"
    getCriteriaSearch(vueInstance, url)
  } else if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_TOOLING_VENDOR_NAME") {
    vueInstance.serachDetailTpye = vueInstance.$t("VENDOR")
    vueInstance.routerValue = vueInstance.getCpcOaCode()
    url = "/cpc/details/"
    getCriteriaSearch(vueInstance, url)
  }
}

function getSearch(vueInstance, url) {
  if (url == "" || vueInstance.routerValue == "") {
    vueInstance.Back()
  } else {
    vueInstance.toggleLoading(true)
    vueInstance.$quotationHttp
      .get(url)
      .then((response) => {
        vueInstance.toggleLoading(false)
        vueInstance.quotationsList = []
        if (response.data) {
          vueInstance.quotationList = response.data._embedded.cpcQuotationDetailResourceList
          if (vueInstance.quotationList.length == 0) {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        }
      })
      .catch(() => {
        vueInstance.$router.push({ name: 'CPC_MAINTAIN' })
        vueInstance.toggleLoading(false)
      })
  }
}

function getCriteriaSearch(vueInstance, url) {
  if (url == "" || vueInstance.routerValue == "") {
    vueInstance.Back()
  } else {
    let deltaPnArray = []
    vueInstance.getCpcDeltaPn().split(';').forEach(a => {
      deltaPnArray.push(a)
    })

    let vendorPnArray = []
    vueInstance.getCpcVendorPn().split(';').forEach(a => {
      vendorPnArray.push(a)
    })

    let vnCodeArray = []
    vueInstance.getCpcVendorCode().split(';').forEach(a => {
      vnCodeArray.push(a)
    })

    let queryData = {
      "rfqType": vueInstance.getCpcRfqType(),
      "status": vueInstance.getCpcStatusEnum()['statusViewEnum'],
      "deltaPartNos": vueInstance.getCpcDeltaPn() == "" ? [] : deltaPnArray,
      "vendorPartNos": vueInstance.getCpcVendorPn() == "" ? [] : vendorPnArray,
      "vendorCodes": vueInstance.getCpcVendorCode() == "" ? [] : vnCodeArray,
      "fromRfqDate": vueInstance.getCpcFromRfqDate() == "" ? null : moment(vueInstance.getCpcFromRfqDate()).format('YYYY-MM-DD'),
      "toRfqDate": vueInstance.getCpcToRfqDate() == "" ? null : moment(vueInstance.getCpcToRfqDate()).format('YYYY-MM-DD')
    }

    if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_TOOLING_ID") {
      queryData['deltaPartNo'] = vueInstance.getCpcDeltaPnSingle()
    } else if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_TOOLING_VENDOR_NAME") {
      queryData['oaCode'] = vueInstance.getCpcOaCode()
    }
    vueInstance.toggleLoading(true)
    vueInstance.$quotationHttp
      .post(url, JSON.stringify(queryData))
      .then((response) => {
        vueInstance.toggleLoading(false)
        vueInstance.quotationList = []
        if (response.data) {
          vueInstance.quotationList = response.data._embedded.cpcQuotationDetailResourceList
          if (vueInstance.quotationList.length == 0) {
            vueInstance.$Notice.success({
              title: Translate("COMMON_MESSAGE_INFO"),
              desc: Translate("COMMON_MESSAGE_INFO"),
              render: h => {
                return h('span', [
                  Translate("COMMON_TEXT_NOTHING")
                ])
              }
            });
          }
        }
      })
      .catch(() => {
        vueInstance.Back()
        vueInstance.toggleLoading(false)
      })
  }
}

function approveGroup(groupRequestData, vueInstance) {
  return vueInstance.$quotationHttp
    .post("/cpc/tooling/group/approve", JSON.stringify(groupRequestData))
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      if (error.response.status == 444) {
        let text = vueInstance.$buildErrorMessage(error)
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}

function unGroup(quotation, vueInstance) {
  return vueInstance.$quotationHttp
    .put("/cpc/ungroup/" + vueInstance.routerValue + "/" + quotation.id + "/" + quotation.formNo)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      if (error.response.status == 444) {
        let text = vueInstance.$buildErrorMessage(error)
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}

function buildCpcRequestData(vueInstance, quotation) {
  return {
    "uuid": quotation.uuid,
    "formNo": quotation.formNo,
    "price": quotation.price,
    "currency": quotation.currency,
    "targetPrice": quotation.targetPrice,
    "comments": quotation.comments,
    "remark": quotation.remark,
    "cpcToSupervisorAttachments": quotation.cpcToSupervisorAttachments,
    "cpcToVendorAttachments": quotation.cpcToVendorAttachments,
    "toolingId": quotation.toolingId,
    "annualProductionCapacity": vueInstance.annualProductionCapacity,
    "annualOutputValue": vueInstance.annualOutputValue,
    "yearOfUse": vueInstance.yearOfUse,
    "recyclingYear": vueInstance.recyclingYear,
    "benefitAnalysis": vueInstance.benefitAnalysis
  }
}

function validation(quotationsList, vueInstance) {
  let errorMessage = ""
  quotationsList.forEach(quotation => {
    if (quotation.action == "Approve" || quotation.action == "Rejected" || quotation.action == "Cancel") {
      if (!quotation.comments) {
        errorMessage = errorMessage + quotation.formNo + ": " + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('COMMENTS') + " <br>"
      }
    }
  })
  if (errorMessage) {
    vueInstance.toggleLoading(false)
    AlertInfo(vueInstance, errorMessage).then(() => {
    })
  }
  return errorMessage == ""
}

</script>

<style scoped>
/* table {
  width: 200% !important;
} */
</style>
